import styles from "./index.module.less";
import img1 from "./imgs/news_1.png";
import img2 from "./imgs/news_2.png";
import img3 from "./imgs/news_3.png";
import img4 from "./imgs/news_4.png";
import news from "./imgs/news.png";
import arrowBlack from "./imgs/arrow_black.png";
import arrowOrange from "./imgs/arrow_gray.png";
import Lottie from "lottie-react";
import tiaozhuan from "@/assets/lottie/tiaozhuan.json";
import { useRef } from "react";
import useHoverLottie from "@/hooks/useHoverLottie";
import { Typography } from "antd";
import newsData from "@/pages/news/data";
import classNames from "classnames";
const { Paragraph } = Typography;
const focusList = [
  {
    title: "中汇人寿首位数字员工e小汇：首次亮相即承担“重任”",
    description:
      "7月8日，中汇人寿“健康是福”中高端医疗保险产品发布会召开。会上，由小冰科技打造的中汇人寿首位数字员工e小汇，联手中汇人寿总公司营销部主持人，共同解读中汇人寿首款中高端医疗保险产品“健康是福”。两“人”配合默契，讲解相得益彰，向近万名保险顾问全方位解锁这款产品的硬核实力。",
    img: img2,
    cover: newsData.newsList.find(item => item.title === '中汇人寿首位数字员工e小汇：首次亮相即承担“重任”').img,
    link: "https://mp.weixin.qq.com/s/DbTyHE1FyIcYpEyWQREfUg",
  },
  {
    title: "港股首例！小冰科技赋能，德林控股首次管理层AI数字员工业绩发布会",
    description:
      "6月26日，德林控股举行2024-2025全年业绩发布会，采用AI数字员工进行发布，在港股市场尚属首次，标志着AI数字员工技术在金融核心业务场景的深度落地。其中的AI数字员工均由小冰生成，核心技术源自小冰“数字大脑+神经网络视觉渲染”方案。",
    img: img2,
    cover: newsData.newsList.find(item => item.title === '港股首例！小冰科技赋能，德林控股首次管理层AI数字员工业绩发布会').img,
    link: "https://mp.weixin.qq.com/s/HfOB37XqtZ_E_NJn-60fpg",
  },
  {
    title: "IDC公布中国AI数字人市场份额，小冰排名领先",
    description:
      "全球权威机构IDC今日发布《中国AI数字人市场份额，2024》报告。报告指出，在2024年中国AI数字人市场份额及2D数字人细分市场中，排名前三的厂商均为：百度、华为云、小冰。",
    img: img2,
    cover: newsData.newsList.find(item => item.title === 'IDC公布中国AI数字人市场份额，小冰排名领先').img,
    link: "https://mp.weixin.qq.com/s/5---cTfl3JJhEoT97lwq3Q",
  },
];
const FocusCard = ({
  title,
  description,
  img,
  cover,
}: {
  title: string;
  description: string;
  img: string;
  cover?: string;
}) => {
  const { lottieOptions, playLottieOnce, stopLottie } = useHoverLottie({
    animationData: tiaozhuan,
  });
  return (
    <div
      className={styles.focusCard}
      onMouseEnter={playLottieOnce}
      onMouseLeave={stopLottie}
      onClick={() =>
        window.open(focusList.find((item) => item.img === img)?.link, "_blank")
      }
    >
      <div className={styles.focusCardLeft}>
        <svg
          viewBox="0 0 197 90"
          className={classNames(styles.focusCardImg, styles.focusCardCover)}
        >
          <defs>
            <clipPath id="myClip">
              <path d="M21.7433 3.32999L0.895108 39.392C-0.27908 41.423 -0.299292 43.9218 0.841885 45.9715L23.2623 86.2429C24.439 88.3564 26.6681 89.6667 29.0871 89.6667H166.937C169.354 89.6667 171.581 88.3586 172.759 86.248L195.502 45.4817C196.649 43.4266 196.627 40.9192 195.445 38.8844L174.779 3.31745C173.586 1.26373 171.39 0 169.015 0H27.5149C25.1345 0 22.9347 1.2692 21.7433 3.32999Z" />
            </clipPath>
          </defs>
          <image
            href={cover}
            width="100%"
            height="100%"
            preserveAspectRatio="xMidYMid slice"
            clipPath="url(#myClip)"
          />
        </svg>
        <img className={styles.focusCardImg} src={img} />
        <div className={styles.focusCardBottom}>
          <img src={arrowBlack} />
        </div>
        <Lottie className={styles.focusCardArrow} {...lottieOptions} />
      </div>
      <div className={styles.focusCardRight}>
        <Paragraph
          ellipsis={{
            rows: 2,
            expandable: false,
            tooltip: title,
          }}
          className={styles.focusTitle}
        >
          {title}
        </Paragraph>
        <Paragraph
          ellipsis={{
            rows: 4,
            expandable: false,
          }}
          className={styles.focusDescription}
        >
          {description}
        </Paragraph>
      </div>
    </div>
  );
};
const FocusList = () => {
  const { lottieOptions, playLottieOnce, stopLottie } = useHoverLottie({
    animationData: tiaozhuan,
  });
  return (
    <div className={styles.focusList}>
      <div
        className={styles.left}
        onMouseEnter={playLottieOnce}
        onMouseLeave={stopLottie}
        onClick={() => window.open(newsData.newsList[0].link, "_blank")}
      >
        <div className={styles.leftImg}>
          <img src={img1} />
        </div>
        <div className={styles.leftTop}>
          <img src={news} />
        </div>
        <div className={styles.leftBottom}>
          <img src={arrowOrange} />
        </div>
        <Lottie className={styles.focusCardArrow} {...lottieOptions} />
        <div className={styles.firstCardContent}>
          <h3 className={styles.focusTitle}>{newsData.newsList[0].title}</h3>
          <div className={styles.focusDescription}>
            {newsData.newsList[0].date}
          </div>
        </div>
      </div>
      <div className={styles.right}>
        {focusList.map((item, index) => (
          <FocusCard key={index} {...item} />
        ))}
      </div>
    </div>
  );
};
export default FocusList;
